export default "__VITE_ASSET__BMjfRdq7__ 400w, __VITE_ASSET__8$mWMedp__ 800w, __VITE_ASSET__TKGGQfb3__ 1024w";